import { translations } from './translations.js';

export const JOURNEY_EXPLANATION_TRANSLATIONS_BATCH8 = Object.freeze(translations);

export function getJourneyExplanationTranslationBatch8(language, journeyId, stageId) {
  const normalizedLanguage = String(language || '').toLowerCase().split('-')[0];
  const templateId = String(journeyId || '').replace(/^generic-/, '');
  return JOURNEY_EXPLANATION_TRANSLATIONS_BATCH8[normalizedLanguage]?.[templateId]?.[stageId] || null;
}
